import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import {
  CardLimits,
  ExaminingTeamMembers,
} from '../SessionsParametersDialogContent/SessionsParametersDialogContent.types';
import { SessionsParametersKeyExaminer } from '../SessionsParametersCardLimit/SessionsParametersCardLimit.types';
import { useStyles } from '../SessionsParametersCardLimit/SessionsParametersLimitCell/SessionsParametersLimitCell.styles';
import TooltipOne from '../../../../components/TooltipOne/TooltipOne.component';
import { getTooltipTitleCardLimit } from '../SessionsParametersCardLimit/helpers';
import SwitchOne from '../../../../components/SwitchOne/SwitchOne.component';

interface SessionsParametersCardLimitCellProps {
  type: SessionsParametersKeyExaminer;
  value: ExaminingTeamMembers;
  initialValue: number;
  defaultValue: number;
  defaultCardLimit: CardLimits;
  handleValueChange: (type: SessionsParametersKeyExaminer, value: number, id: string | number) => void;
  handleSwitchChange: (type: SessionsParametersKeyExaminer, value: boolean, id: string | number) => void;
  validation?: (type: SessionsParametersKeyExaminer, value: number, limits: ExaminingTeamMembers) => boolean;
  isValid?: boolean;
  examinerFullName?: string;
}

export const SessionsParametersCardLimitCellPerExaminer: React.FC<SessionsParametersCardLimitCellProps> = ({
  type,
  value,
  initialValue,
  defaultValue,
  handleValueChange,
  handleSwitchChange,
  validation,
  isValid,
  examinerFullName,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const styles = useStyles();

  useEffect(() => {
    if (initialValue === defaultValue) {
      setIsChecked(false);
    } else {
      setIsChecked(true);
    }
  }, [initialValue, defaultValue]);

  const onValueChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const val = parseInt(e.target.value, 10);
      if (validation) {
        validation(type, val, value);
      }
      handleValueChange(type, val, value.examinerId);
    },
    [type, value, handleValueChange, validation],
  );

  const onSwitchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setIsChecked(checked);
      handleSwitchChange(type, checked, value.examinerId);
      if (validation) {
        validation(type, checked ? defaultValue + 1 : defaultValue, value);
      }
    },
    [handleSwitchChange, type, value.examinerId, validation, defaultValue],
  );

  return (
    <Grid container wrap="nowrap" style={{ height: 50, alignItems: 'center' }}>
      <TextField
        name={type}
        onChange={onValueChange}
        variant="outlined"
        type="number"
        disabled={!defaultValue}
        inputProps={{
          style: {
            padding: '7px',
            width: '70px',
            fontSize: '1rem',
            height: 20,
          },
          min: 1,
        }}
        value={initialValue || ''}
        error={isValid}
      />
      <div className={styles.switch}>
        <TooltipOne title={getTooltipTitleCardLimit(type as string, isChecked, examinerFullName)} placement="top">
          <span>
            <SwitchOne
              disabled={!defaultValue}
              disableRipple
              checked={isChecked}
              color={'primary'}
              onChange={onSwitchChange}
              inputProps={{
                'aria-label': 'limit',
              }}
            />
          </span>
        </TooltipOne>
      </div>
    </Grid>
  );
};
